import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=6ed06f54"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=6ed06f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports